// Module
var code = "<positionInfoView position=\"{{position}}\" />\r\n\r\n<terceraSeparator />\r\n\r\n<div class=\"position-controls-container\">\r\n    <div class=\"order-edit-parameters\">\r\n        {{>orderEditControls orderEditParameterArray}}\r\n    </div>\r\n</div>\r\n\r\n<terceraSeparator />";
// Exports
export default code;